import { render, staticRenderFns } from "./NewEditOrganization.vue?vue&type=template&id=7572444e&"
import script from "./NewEditOrganization.vue?vue&type=script&lang=ts&"
export * from "./NewEditOrganization.vue?vue&type=script&lang=ts&"
import style0 from "./NewEditOrganization.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports